export const tariffData2AggregatedRows = (data: any): any[] => {
  // console.log(data);
  const tariffDetails = data?.tariffDetails;
  const taxes = tariffDetails?.taxes;
  const metersInfo = tariffDetails?.metersInfo;
  let finalArray: any[] = [];

  if (Array.isArray(metersInfo) && metersInfo.length > 0) {
    metersInfo.map((obj: any) => {
      const foundTax = taxes.find(
        (tax: any) => tax.meteringPointId === obj.meter,
      );
      let mergedObject = {
        ...obj,
        ...foundTax,
      };
      delete mergedObject.nettariffHourly;
      delete mergedObject.rabatNettariffHourly;
      finalArray.push(mergedObject);
    });
  }
  return finalArray;
};
